const international = {
  hero: {
    eyebrow: "Глобальный портфель",
    title:   "Зарубежная",
    titleEm: "недвижимость",
    sub:     "Эксклюзивные объекты за пределами ОАЭ — подборка от ProNet Real Estate.",
  },
  filter: {
    all: "Все",
  },
  count_one:   "{{count}} объект",
  count_few:   "{{count}} объекта",
  count_many:  "{{count}} объектов",
  count_other: "{{count}} объектов",
  card: {
    bedrooms:  "сп.",
    bathrooms: "ванн.",
  },
  detail: {
    forSale:        "Продажа",
    breadcrumb:     "Зарубежная недвижимость",
    bedrooms:       "Спальни",
    bathrooms:      "Ванные",
    builtArea:      "м² жилой",
    plotArea:       "м² участок",
    description:    "Описание",
    amenities:      "Удобства и особенности",
    details:        "Детали",
    type:           "Тип",
    status:         "Статус",
    location:       "Расположение",
    builtAreaLabel: "Жилая площадь",
    plotAreaLabel:  "Площадь участка",
    priceIn:        "Цена в {{currency}}",
    whatsapp:       "Написать в WhatsApp",
    viewSite:       "Смотреть на сайте ↗",
    allPhotos:      "Все фото",
    viewAll_one:    "Смотреть {{count}} фото",
    viewAll_few:    "Смотреть {{count}} фото",
    viewAll_many:   "Смотреть {{count}} фото",
    viewAll_other:  "Смотреть {{count}} фото",
    notFound:       "Объект не найден",
    back:           "← Назад к зарубежной недвижимости",
  },
};

export default international;
